import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import ObservationTypeSection from './components/ObservationTypeSection';
import SeverityAssessment from './components/SeverityAssessment';
import LocationSpecification from './components/LocationSpecification';
import PersonnelSection from './components/PersonnelSection';
import DescriptionSection from './components/DescriptionSection';
import ImmediateActionSection from './components/ImmediateActionSection';
import RecommendationSection from './components/RecommendationSection';
import PhotoUploadSection from './components/PhotoUploadSection';

const UnsafeActsConditionsEntryForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    observationType: '',
    severity: '',
    location: '',
    equipment: '',
    personnelInvolved: [],
    description: '',
    immediateAction: '',
    recommendation: '',
    photos: [],
    assignedTo: ''
  });

  const [isDraft, setIsDraft] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveDraft = () => {
    setIsDraft(true);
    console.log('Saving draft:', formData);
    // Save to localStorage or backend
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    console.log('Submitting observation:', formData);
    navigate('/unsafe-acts-conditions-analytics-dashboard');
  };

  const handleReportCritical = () => {
    console.log('Reporting critical observation with immediate escalation:', formData);
    navigate('/unsafe-acts-conditions-analytics-dashboard');
  };

  const handleCancel = () => {
    navigate('/unsafe-acts-conditions-analytics-dashboard');
  };

  return (
    <div className="min-h-screen bg-background p-6 lg:p-8">
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <button
            onClick={handleCancel}
            className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-4"
          >
            <Icon name="ArrowLeft" size={20} />
            <span>Back to Analytics</span>
          </button>
          
          <h1 className="text-3xl font-bold text-foreground mb-2">Report Unsafe Act or Condition</h1>
          <p className="text-muted-foreground">
            Document workplace safety observations with comprehensive details for corrective action
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <ObservationTypeSection
            value={formData?.observationType}
            onChange={(value) => handleChange('observationType', value)}
          />

          <SeverityAssessment
            value={formData?.severity}
            onChange={(value) => handleChange('severity', value)}
          />

          <LocationSpecification
            location={formData?.location}
            equipment={formData?.equipment}
            onLocationChange={(value) => handleChange('location', value)}
            onEquipmentChange={(value) => handleChange('equipment', value)}
          />

          <PersonnelSection
            personnel={formData?.personnelInvolved}
            onChange={(value) => handleChange('personnelInvolved', value)}
          />

          <DescriptionSection
            value={formData?.description}
            onChange={(value) => handleChange('description', value)}
          />

          <PhotoUploadSection
            photos={formData?.photos}
            onChange={(value) => handleChange('photos', value)}
          />

          <ImmediateActionSection
            value={formData?.immediateAction}
            onChange={(value) => handleChange('immediateAction', value)}
          />

          <RecommendationSection
            value={formData?.recommendation}
            assignedTo={formData?.assignedTo}
            onRecommendationChange={(value) => handleChange('recommendation', value)}
            onAssignedToChange={(value) => handleChange('assignedTo', value)}
          />

          <div className="flex flex-wrap gap-4 pt-6 border-t border-border">
            <button
              type="button"
              onClick={handleCancel}
              className="px-6 py-3 border border-border rounded-lg text-foreground hover:bg-muted transition-colors"
            >
              Cancel
            </button>
            
            <button
              type="button"
              onClick={handleSaveDraft}
              className="px-6 py-3 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors"
            >
              Save Draft
            </button>
            
            <button
              type="submit"
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              Submit for Review
            </button>
            
            <button
              type="button"
              onClick={handleReportCritical}
              className="px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors ml-auto"
            >
              <Icon name="AlertTriangle" size={20} className="inline mr-2" />
              Report Critical
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UnsafeActsConditionsEntryForm;